import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#000",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("ellipse", {
			cx: 15.797,
			cy: 15.957,
			rx: 14.072,
			ry: 14.019
		}), /* @__PURE__ */ _jsx("polyline", {
			strokeLinecap: "square",
			strokeLinejoin: "round",
			points: "10.773 18.11 14.448 20.963 20.821 10.95"
		})]
	})
});
export default SvgTickinline;
